import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SoCaiService {

  constructor(private httpClient: HttpClient) { }

  deleteSocaiNotExist() {
    return this.httpClient.delete('/api/Socais/DeleteSocaiNotExist');
  }

  danhSoCongChungTrongNam() {
    return this.httpClient.get('/api/Socais/DanhSoCongChungTrongNam');
  }

  saveSoCai(formData: any) {
    return this.httpClient.post('/api/Socais/AddSoCai', formData);
  }

  updateSoCai(id: number, formData: any) {
    return this.httpClient.put('/api/Socais/UpdateSoCai/' + id, formData);
  }

  getLastSoCai(): any {
    return this.httpClient.get('/api/Socais/GetLastSoCai');
  }

  getSoCaiById(id: number) {
    return this.httpClient.get('/api/Socais/' + id);
  }

  findSoCaiByNYC(findValue: string, limit: number, pageNumber: number, tuNgay: String, denNgay: String): any {
    return this.httpClient.get('/api/Socais/FindSoCaiByNYC?searchValue=' + findValue + '&pageSize=' + limit + '&pageNumber='
      + pageNumber + '&tuNgay=' + tuNgay + '&denNgay=' + denNgay);
  }

  countSoCaiByNYC(searchValue: string, tuNgay: String, denNgay: String): any {
    return this.httpClient.get('/api/Socais/CountByNYC?searchValue=' + searchValue + '&tuNgay=' + tuNgay + '&denNgay=' + denNgay);
  }

  findSoCaiByTTTS(findValue: string, limit: number, pageNumber: number, tuNgay: String, denNgay: String): any {
    return this.httpClient.get('/api/Socais/FindSoCaiByThongTinTaiSan?searchValue=' + findValue + '&pageSize=' + limit
      + '&pageNumber=' + pageNumber + '&tuNgay=' + tuNgay + '&denNgay=' + denNgay);
  }

  findSoCaiBySoCongChung(findValue: string, limit: number, pageNumber: number, tuNgay: String, denNgay: String): any {
    return this.httpClient.get('/api/Socais/FindSoCaiBaySoCongChung?soCongChung=' + findValue + '&pageSize=' + limit
      + '&pageNumber=' + pageNumber + '&tuNgay=' + tuNgay + '&denNgay=' + denNgay);
  }

  countSoCaiByTTTS(searchValue: string, tuNgay: String, denNgay: String): any {
    return this.httpClient.get('/api/Socais/CountByThongTinTaiSan?searchValue=' + searchValue + '&tuNgay=' + tuNgay + '&denNgay=' + denNgay);
  }

  countSoCaiBySoCongChung(searchValue: string, tuNgay: String, denNgay: String): any {
    return this.httpClient.get('/api/Socais/CountBySoCongChung?soCongChung=' + searchValue + '&tuNgay=' + tuNgay + '&denNgay=' + denNgay);
  }

  delete(id: number) {
    return this.httpClient.delete('/api/Socais/' + id);
  }

  checkQuyenSuaSoCai(idSoCai: number) {
    return this.httpClient.get('/api/Socais/CheckQuyenSuaHoSo?idSoCai=' + idSoCai);
  }
}
